import type { RecordId } from "../type";
import { useUserInfo } from "@/hooks/services";
import { useSourcingRequirementQuery } from "./useSourcingRequirementQuery";

export function useSourcingBy(recordId?: RecordId) {
  const { userId } = useUserInfo();
  const detail = useSourcingRequirementQuery(recordId ?? null);

  // 是否是寻源负责人（采购）
  const isSourcingBy = Boolean(
    userId && detail?.sourcingBy && userId.toString() === detail.sourcingBy,
  );

  return { isSourcingBy };
}
